import * as jsxRuntime from "C:\\Eidos!!!\\axelhave\\81-eido-axelhave\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment